export default __webpack_public_path__ + "static/media/regulatory--go-straight-or-turn-right--g2.75a12caf.png";